import DashboardComponent from "../../component/dashboard/Dashboard";
export default function Dashbaord(){

    return <DashboardComponent>
                    <h1 style={{color: "#A9B892"}}>Welcome to the dashboard</h1>
        </DashboardComponent>
}